import React, { useContext, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Modal,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import inescologo from 'src/Resources/Logo.svg';

import { UserContext } from 'src/contexts/userContext';
import { TokenContext } from 'src/contexts/tokenContext';
import Avatar from '@mui/material/Avatar';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import axiosConfig from 'src/Resources/axiosConfig';
import { useNavigate } from 'react-router-dom';
import routes from 'src/Resources/routes.json';

interface ForgotPasswordPromps {
  resetPassword: () => void;
}

function ForgotPassword() {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const theme = useTheme();
  const context = useContext(UserContext);

  if (!context) {
    return null;
  }
  const { currentUser, setUser, removeUser } = context;
  const tokencontext = useContext(TokenContext);
  const { token, setNewToken, removeToken } = tokencontext;
  const navigate = useNavigate();

  const handleUsernameChange = (e) => {
    const { name, value } = e.target;
    setUsername(value);
  };

  const handleReturn = () => {
    setOpen(false);
    navigate(routes.login);
    //props.resetPassword();
  };

  const handleSubmit = () => {
    setLoading(true);

    axiosConfig
      .post(`/ResetPasswordRequest?username=${username}`)
      .then((response) => {
        if (response) {
          setLoading(false);
          setOpen(true);
        }
      })
      .catch((error) => {
        setLoading(false);
        setErrorModalOpen(true);

        if (error.response && error.response.status == 401) {
          removeToken();
        }
      });
  };

  return (
    <>
      <Container maxWidth="xl" sx={{ pt: 2 }}>
        <Grid container>
          <Grid item xs={3} container justifyContent="flex-start" mb={2}>
            <a href="https://monitor.inesco.energy/">
              <img src={inescologo} alt="inesco logo" height="100" />
            </a>
          </Grid>
        </Grid>
      </Container>

      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: 500,
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          p: 6,
          position: 'absolute',
          top: '30%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: '#00b33c' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Provide your username
        </Typography>
        <Box
          component="form"
          noValidate
          sx={{
            mt: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <TextField
            label="User Name"
            variant="outlined"
            type="username"
            value={username}
            onChange={handleUsernameChange}
            fullWidth
            margin="normal"
            required
            sx={{ width: 350 }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmit();
              }
            }}
          />

          {loading && <CircularProgress sx={{ color: '#00b33c' }} />}

          <Button
            sx={{
              mt: 3,
              mb: 2,
              textTransform: 'none',
              bgcolor: '#00b33c',
              '&:hover': { bgcolor: '#009933' }
            }}
            variant="contained"
            fullWidth={true}
            color="primary"
            onClick={handleSubmit}
          >
            Submit
          </Button>

          <Modal
            open={errorModalOpen}
            onClose={() => setErrorModalOpen(false)}
            aria-labelledby="error-modal"
            aria-describedby="error-modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 340,
                bgcolor: 'background.paper',
                borderRadius: 4,
                boxShadow: 24,
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <Typography variant="body1" gutterBottom>
                Username is wrong. Please try again.
              </Typography>
              <Button
                sx={{
                  marginTop: 2,
                  textTransform: 'none',
                  bgcolor: '#00b33c',
                  color: '#111111',
                  '&:hover': { bgcolor: '#009933' }
                }}
                onClick={() => setErrorModalOpen(false)}
              >
                Close
              </Button>
            </Box>
          </Modal>

          <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="error-modal"
            aria-describedby="error-modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 340,
                bgcolor: 'background.paper',
                borderRadius: 4,
                boxShadow: 24,
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <Typography variant="body1" gutterBottom>
                Mail sent successfully.
              </Typography>
              <Button
                sx={{
                  marginTop: 2,
                  textTransform: 'none',
                  bgcolor: '#00b33c',
                  color: '#111111',
                  '&:hover': { bgcolor: '#009933' }
                }}
                onClick={handleReturn}
              >
                Close
              </Button>
            </Box>
          </Modal>
        </Box>
      </Box>
    </>
  );
}

export default ForgotPassword;
